import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { StateService } from "../services/StateService";
import classNames from "classnames";
import lineOne from "../assets/line-1.png";
import lineTwo from "../assets/line-2.png";
import internetLogo from "../assets/internet.png";
import buildLogo from "../assets/build-logo.png";
import protectionLogo from "../assets/protection.png";

const useStyles = makeStyles((theme) => ({
  auctionPageTitle: {
    marginTop: "50px",
    fontWeight: 500,
    color: "#F782ED",
    fontSize: "38px",
    fontFamily: "Gilroy-Medium, sans-serif",
  },
  auctionPageInfo: {
    color: "white",
    width: "38%",
    letterSpacing: "1px",
    fontSize: "18px",
    marginTop: "20px",
    fontFamily: "Gilroy-Regular, sans-serif",
    margin: "0 auto",
    marginBottom: "24px",
  },
  grid: {
    display: "flex",
    justifyContent: "center",
  },
  gridSecond: {
    marginTop: "70px",
  },
  cardSection: {
    marginTop: "50px",
    flexGrow: 1,
    width: "100%",
  },
  cardLeftRight: {
    height: "344px",
  },
  cardMiddle: {
    height: "344px",
  },
  card: {
    // backgroundColor: 'black',
    background: 'linear-gradient(270deg, #3457F2 0%, #B139D8 100%)',
    color: 'white',
    width: '60%',
    borderRadius: '20px',
    paddingBottom: '10px',
    position: 'relative',
  },
  media: {
    height: "196px",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    background: "transparent",
    backgroundColor: "rgba(33, 35, 40, 1)",
    borderRadius: 0,
  },
  img: {
    width: "120px",
    height: "120px",
    backgroundSize: "contain",
  },
  content: {
    backgroundColor: "rgba(33, 35, 40, 1)",
    paddingTop: "0",
    paddingLeft: "19px",
    paddingRight: "19px",
  },

  cardTitle: {
    color: "#F782ED",
    fontWeight: 700,
    fontFamily: "Gilroy-Medium, sans-serif",
    fontSize: "23px",
  },
  firstImage: {
    position: "absolute",
    width: "189px",
    height: "189px",
    left: "381px",
    top: "132px",
  },
  secondImage: {
    position: "absolute",
    width: "189px",
    height: "189px",
    top: "64px",
    right: "381px",
  },
}));

interface HowWorksProps {
  state: StateService;
}

export const HowItWorks = observer((props: HowWorksProps) => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12}>
        <div className={classes.auctionPageTitle}>How It Works</div>
        <div className={classes.auctionPageInfo}>
          This is a multi-stage event where users compete in a bidding contest
          in order to win the opportunity to collaborate together and generate
          shared NFT artworks!
        </div>
      </Grid>
      <Grid container style={{ position: "relative" }}>
        <CardMedia image={lineOne} title="" className={classes.firstImage} />
        <CardMedia image={lineTwo} title="" className={classes.secondImage} />
        <Grid item xs={4} className={classes.grid}>
          <Card className={classNames(classes.card, classes.cardLeftRight)}>
            <Paper elevation={0} className={classes.media}>
              <CardMedia
                className={classes.img}
                image={internetLogo}
                title="Vote"
              />
            </Paper>
            <CardContent className={classes.content}>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className={classes.cardTitle}
              >
                AUCTION
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                style={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "Gilroy-Regular, sans-serif",
                  fontSize: "16px",
                  marginBottom: "13px",
                }}
              >
                Join in the auction to be the part of the lucky few to generate
                the NFT Art
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={4}
          className={classNames(classes.grid, classes.gridSecond)}
        >
          <Card className={classNames(classes.card, classes.cardMiddle)}>
            <Paper elevation={0} className={classes.media}>
              <CardMedia
                className={classes.img}
                image={buildLogo}
                title="Vote"
              />
            </Paper>
            <CardContent className={classes.content}>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className={classes.cardTitle}
              >
                BUILD
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                style={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "Gilroy-Regular, sans-serif",
                  fontSize: "16px",
                  marginBottom: "13px",
                }}
              >
                Collaboratively generate entropy which is essential for the
                generation of the NFT art
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4} className={classes.grid}>
          <Card className={classNames(classes.card, classes.cardLeftRight)}>
            <Paper elevation={0} className={classes.media}>
              <CardMedia
                className={classes.img}
                image={protectionLogo}
                title="Vote"
              />
            </Paper>
            <CardContent className={classes.content}>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className={classes.cardTitle}
              >
                VOTE
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                style={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "Gilroy-Regular, sans-serif",
                  fontSize: "16px",
                  marginBottom: "13px",
                }}
              >
                Inspect and Vote on your favorite artwork to create the final
                NFTs
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
});
